// const baseURL = "http://localhost:3001/api/v1";
const baseURL = "https://backendfitness-zahu.onrender.com/api/v1"

export default baseURL;
